<template>
  <div class="detail-card">
    <div class="title">
      <div class="my-breadcrumb pdb20">
        <span>我的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoice/index' }">发票管理</el-breadcrumb-item>
          <el-breadcrumb-item>发票详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="order-info" v-loading="loading">

      <el-alert class="mgb20" v-if="invoice.status == 2" show-icon :title="`驳回原因：${invoice.reason}`" type="error"
        :closable="false">
      </el-alert>

      <div class="status">
        <img v-if="invoice.status == 0" src="@/assets/images/invoice0.png" alt="" />
        <img v-if="invoice.status == 1" src="@/assets/images/invoice1.png" alt="" />
        <img v-if="invoice.status == 2" src="@/assets/images/invoice2.png" alt="" />
      </div>
      <el-descriptions title="发票详情" :column="3">
        <el-descriptions-item label="发票编号">{{ invoice.invoice_no }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ invoice.create_time }}</el-descriptions-item>
        <el-descriptions-item label="发票状态">{{ invoice.status_name }}</el-descriptions-item>
        <el-descriptions-item label="发票金额" :span="3">{{ formatPrice(invoice.price) }}</el-descriptions-item>
        <el-descriptions-item label="发票类型" :span="3">{{ invoice.type_name }}</el-descriptions-item>
        <el-descriptions-item label="出票公司" :span="3">{{ invoice.header_name }}</el-descriptions-item>
        <el-descriptions-item label="发票抬头" :span="3">{{ invoice.name }}</el-descriptions-item>
        <el-descriptions-item label="纳税人识别号" :span="3">{{ invoice.tax_no }}</el-descriptions-item>
        <el-descriptions-item label="开户行名称" :span="3">{{ invoice.bank_name }}</el-descriptions-item>
        <el-descriptions-item label="开户行账号" :span="3">{{ invoice.bank_account }}</el-descriptions-item>
        <el-descriptions-item label="营业场所地址" :span="3">{{ invoice.address }}</el-descriptions-item>
        <el-descriptions-item label="注册固定电话" :span="3">{{ invoice.tel }}</el-descriptions-item>
      </el-descriptions>
      <div class="flex-row mgt10">
        <div class="flex-row">
          <el-button type="primary" v-if="invoice.voucher" size="mini"
            @click="downloadInvoice(invoice.voucher[0])">下载电子发票</el-button>
          <el-button type="primary" size="mini" @click="downloadList(invoice.id)">下载清单</el-button>
          <el-button type="primary" size="mini" @click="downloadContract(invoice.id)">下载合同</el-button>
          <el-tooltip class="item" effect="light" content="合同盖章后请拍照上传" placement="right">
            <el-button type="danger" size="mini" @click="handleShowUploadContractForm(invoice.id)">上传合同</el-button>
          </el-tooltip>
        </div>
      </div>
      <el-descriptions class="mgt30" title="开票明细">
      </el-descriptions>
      <el-table :data="invoice.items" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border
        fit highlight-current-row>
        <el-table-column label="发票项目" align="center" minWidth="150" prop="body">
        </el-table-column>
        <el-table-column label="单价" align="center" width="150">
          <template slot-scope="{row}">
            {{ formatPrice(row.price) }}
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" width="150" prop="num">
          <template slot-scope="{row}">
            {{ row.num || 1 }}
          </template>
        </el-table-column>
        <el-table-column label="金额" align="center" minWidth="180">
          <template slot-scope="{row}">
            {{ formatPrice(row.price) }}
          </template>
        </el-table-column>
      </el-table>
      <el-descriptions class="mgt20" :column="1">
        <el-descriptions-item label="合计金额（小写）">{{ formatPrice(invoice.price) }}</el-descriptions-item>
        <el-descriptions-item label="合计金额人民币（大写）">{{ invoice.big_price }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 上传合同 -->
    <upload-contract :invoiceId="invoiceId" :visible.sync="showUploadContractForm" @success="getInvoiceDetail" />
  </div>
</template>

<script>

import { getInvoiceDetail, setFinish, setDelete } from "@/api/invoice";
import { getConfig } from "@/api/common";
import UploadContract from './components/uploadContract';

export default {
  name: "InvoiceDetail",
  components: {
    UploadContract

  },
  props: {},
  data() {
    return {
      invoiceId: 0,
      invoice: {},
      config: {},
      emptyText: '暂无数据',
      loading: false,
      showUploadContractForm: false,
    }
  },
  filters: {

  },
  computed: {

  },
  created() {
    this.formatPrice = this.utils.formatPrice
    this.invoiceId = this.$route.query.id
    this.getConfig()
    this.getInvoiceDetail()
  },
  mounted() {

  },
  updated() {

  },
  methods: {
    getConfig() {
      getConfig({ group: 'account' }).then((res) => {
        this.config = res.data
      }).catch((err) => {
        console.log(err);
      })
    },
    getInvoiceDetail() {
      this.loading = true;
      getInvoiceDetail({ id: this.invoiceId }).then((res) => {
        this.loading = false;
        this.invoice = res.data
      }).catch((err) => {
        this.loading = false;
        console.log(err);
      })
    },
    handleShowUploadContractForm() {
      this.showUploadContractForm = true;
    },
    downloadInvoice(file) {
      window.open(file.url, '_blank')
    },
    downloadList() {
      let routeData = this.$router.resolve({ path: '/print/list', query: { id: this.invoiceId } });
      window.open(routeData.href, '_blank');
      // window.open(this.invoice.list_url, '_blank')
    },
    downloadContract() {
      let routeData = this.$router.resolve({ path: '/print/contract', query: { id: this.invoiceId } });
      window.open(routeData.href, '_blank');
      // window.open(this.invoice.contract_url, '_blank')
    },
  }
};
</script>

<style lang="scss" scoped>
.detail-card {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
  border-radius: 2px;
  margin-top: 16px;

  .title {
    width: 100%;
    padding: 19px 25px 0 25px;
    border-bottom: 1px solid #CCD7DB;
  }

  .order-info {
    width: 100%;
    padding: 17px 27px 30px 27px;
    box-sizing: border-box;
    position: relative;

    .status {
      position: absolute;
      top: 150px;
      right: 100px;

      img {
        width: 200px;
      }
    }

  }

  .tips {
    color: #FF6666;
    font-size: 14px;
    border: 1px solid #FF6666;
    line-height: 30px;
    height: 30px;
    padding: 0 10px;
    border-radius: 5px;
  }

}
</style>
